import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]

import { computed, ref, watch, PropType } from 'vue';
import { useQueueStore } from '@/stores/queueStore';
import BTable from "./BTable/BTable.vue";
import BTableHeader from "./BTable/BTableHeader.vue";
import { BTableColumn, BTableOptions } from './BTable/BTable.types';
import { AxiosResponse } from 'axios';
import QueuePauseButton from './QueuePauseButton.vue';
import { QueueItem } from '@/types';
import { BFilter, BFilterableField } from './BFilterEditor/BFilterEditor.types';


export default /*#__PURE__*/_defineComponent({
  __name: 'Tasks',
  props: {
    showPauseResumeButton: { type: Boolean }
  },
  setup(__props: any) {

const props = __props
const queueStore = useQueueStore();

//table settings and column info
var tableOptions= ref({
                        totalItemCount: 0,
                        itemsPerPage: 25,
                        page: 1,
                        sortBy: [{
                            key: 'start',
                            isDescending: true
                        }]
                    } as BTableOptions);

const columns = computed(() => {

    let data: BTableColumn[] = [];

    data.push({ key: 'status', text: 'Status', sortable: false, value: (item) => item.status },
        { key: 'type', text: 'Type', sortable: false, value: (item) => item.type },
        { key: 'start', text: 'Start', sortable: false, value: (item) => item.start },
        { key: 'end', text: 'End', sortable: false, value: (item) => item.end });

    return data;
});
 
var queueItems = ref([] as QueueItem[]);
function getQueueItems(){
    queueStore.getQueueItems(tableOptions.value.page, tableOptions.value.itemsPerPage, [] as BFilter[], [] as BFilterableField[], tableOptions.value.sortBy).then((response) => {
        tableOptions.value.totalItemCount = response.data.total;
        if(Array.isArray(response.data.data)){
            queueItems.value = response.data.data;
        }
    });
}

function handleOptionChange() {
    getQueueItems();
}

getQueueItems();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BTableHeader, {
      value: _unref(tableOptions),
      "header-slot-class": "b-header-slot w-100",
      onOptionChange: handleOptionChange
    }, {
      default: _withCtx(() => [
        _createVNode(QueuePauseButton, {
          "show-pause-resume-button": props.showPauseResumeButton,
          "container-class": "position-relative top-50"
        }, null, 8, ["show-pause-resume-button"]),
        _renderSlot(_ctx.$slots, "header.toolbar")
      ]),
      _: 3
    }, 8, ["value"]),
    _createVNode(BTable, {
      items: _unref(queueItems),
      columns: columns.value,
      caption: "Task list",
      value: _unref(tableOptions),
      class: "mt-1"
    }, {
      "cell.fileName": _withCtx(({item, column}) => [
        _createElementVNode("span", {
          innerHTML: item.fileName
        }, null, 8, _hoisted_2)
      ]),
      "cell.status": _withCtx(({item, column}) => [
        _createElementVNode("span", {
          innerHTML: item.status
        }, null, 8, _hoisted_3)
      ]),
      _: 1
    }, 8, ["items", "columns", "value"])
  ]))
}
}

})